module.exports = __webpack_public_path__ + "static/media/no-calculator.6c45a56f.svg";